import {
  Component,
  ChangeDetectorRef,
  OnDestroy,
  OnInit,
  ViewEncapsulation,
  Input,
  ViewChild,
  ElementRef,
  TemplateRef,
  EventEmitter,
  Output,
} from '@angular/core';
import { Subject, switchMap, tap } from 'rxjs';
import { Pipeline, Project, User } from 'app/modules/projects/projects.types';
import { AccountService } from 'app/core';
import { Account } from 'app/core/models/account.types';
import { HttpClient } from '@angular/common/http';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { UserService } from 'app/layout/common/user/user.service';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { Engagement } from '../engagements.types';
import { EngagementsService } from '../engagements.service';
import { ConfirmService } from 'app/shared/components/widgets/dialog/confirm/confirm.service';
import { OnDestroyMixin, untilComponentDestroyed } from '@w11k/ngx-componentdestroyed';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { filter } from 'rxjs/operators';
import { NewPermission } from '@core/enums';

@Component({
  selector: 'engagements-crm-panel',
  templateUrl: './engagements-crm-panel.component.html',
  styleUrls: ['./engagements-crm-panel.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class EngagementsCrmPanelComponent extends OnDestroyMixin implements OnInit, OnDestroy {
  pipelines: Pipeline[];
  account: Account;
  _engagements: Engagement[];
  protected readonly NewPermission = NewPermission;

  private _unsubscribeAll: Subject<void>;

  get engagements() {
    return this._engagements;
  }

  @Input() set engagements(values: any) {
    if (values) {
      this._engagements = values;
    }
  }

  @Output() onRefetchEngagements = new EventEmitter();
  @Output() onEditEngagement = new EventEmitter();

  constructor(
    private _changeDetectorRef: ChangeDetectorRef,
    private _accountService: AccountService,
    private _formBuilder: UntypedFormBuilder,
    private _httpClient: HttpClient,
    private _activatedRoute: ActivatedRoute,
    private engagementsService: EngagementsService,
    private readonly confirmService: ConfirmService,
    private _userService: UserService,
    private readonly matDialog: MatDialog,
    private readonly snackBar: MatSnackBar,
  ) {
    super();
    this._accountService.currentAccount.subscribe((accountData) => {
      this.account = accountData;
    });
    this._unsubscribeAll = new Subject();
  }

  ngOnInit(): void {}

  ngOnDestroy(): void {
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }

  trackByFn(index: number, item: any): any {
    return item.id || index;
  }

  editEngagement(engagement: Engagement): void {
    this.onEditEngagement.emit(engagement);
  }

  deleteEngagement(engagement: Engagement): void {
    this.confirmService
      .openConfirmationModal()
      .pipe(
        untilComponentDestroyed(this),
        filter((res: boolean) => res),
        switchMap(() => this.engagementsService.deleteEngagement(engagement.id)),
        tap(() => {
          this.snackBar.open('Successfully deleted engagement.', null, {
            duration: 3000,
          });
          this.onRefetchEngagements.emit();
          this._changeDetectorRef.markForCheck();
        }),
      )
      .subscribe();
  }
}
